import { Grid, Box, Typography, Badge, IconButton } from "@mui/material";
import BackLoading, {
  BackLoadingSimple,
} from "../../../composant/loading/backLoading";
import { useEffect, useState, useCallback } from "react";
import imageCompression from "browser-image-compression";
import ImageCard from "../../../composant/imageGallery/ImageGallrey";
import { ImportButton } from "../../../composant/UploadFiles";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DrawerAppBar from "../../../composant/navbar/Navbar";
import "simple-keyboard/build/css/index.css";
import { ConfirmClientTextPopup } from "../../../composant/Popup/confirmClientText";
import axios from "axios";
import { api_base } from "../../../env";
import heic2any from "heic2any";
import SuccessWithRouletteDialog from "../../../composant/Popup/PopupRoulleteSucces";
import PopupChangeBg from "../../../composant/Popup/PopupChangeBg";
import InputClientUploadFiles from "../../../composant/clavie/InputClientUPloadfiles";
import { useEvent } from "../../../service/UseEvent";
import LogoutIcon from "@mui/icons-material/Logout";
import PhotoImportCard from "../../../composant/UploadFiles";
export default function EventUploadPage() {
  const [loading, setLoading] = useState(false);
  const [loadingSimple, setLoadingSimple] = useState(false);
  const [images, setImage] = useState([]);
  //const dataCookie = Cookies.get("dataEvent");
  //  const data = JSON.parse(dataCookie);
  const { EventsData } = useEvent();
  const data = EventsData;
  console.log("dataEvent :", data);
  console.log(data?.Produit);
  const type = data?.Produit?.NomProduit;
  const dataProduit = data?.Produit;
  // clavie

  const [progress, setProgress] = useState(0);
  const [code, setCode] = useState();
  const [Roullete, setRoullete] = useState(false);
  //
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [PopupChangeBgEtat, setPopupChangeBgEtat] = useState(false);
  const [indexImageChangeBg, SetIndexImageChangeBg] = useState();
  //  const [step, setStep] = useState("intro");
  const step = "intro"; // IGNORE
  const { logoutEvent } = useEvent();

  // end clavie

  async function AddImage(e) {
    setLoadingSimple(true);
    let acceptedFiles = [];

    // Handle camera (data URL string) or file input event
    if (typeof e === "string") {
      // e is a data URL from camera
      const dataUrl = e;
      // Convert dataURL to Blob
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `camera_${Date.now()}.jpg`, {
        type: "image/jpeg",
      });
      acceptedFiles = [file];
    } else if (e && e.target && e.target.files) {
      acceptedFiles = Array.from(e.target.files);
    } else {
      setLoadingSimple(false);
      return;
    }

    const imageUploadPromises = acceptedFiles.map(async (file) => {
      try {
        let convertedFile = file;
        // Detect HEIC and convert
        if (file.type === "image/heic" || file.name.endsWith(".heic")) {
          const blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          });
          convertedFile = new File(
            [blob],
            file.name.replace(/\.heic$/i, ".jpg"),
            {
              type: "image/jpeg",
            }
          );
        }
        const options = {
          maxSizeMB: 0.5,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        return await imageCompression(convertedFile, options);
      } catch (err) {
        console.error("Error during conversion or compression:", err);
        throw err;
      }
    });

    try {
      const results = await Promise.allSettled(imageUploadPromises);
      const compressedFiles = results
        .filter((result) => result.status === "fulfilled")
        .map((result) => result.value);
      const failedFiles = results
        .filter((result) => result.status === "rejected")
        .map((_, index) => acceptedFiles[index]);
      const newImages = compressedFiles.map((compressedFile, index) => ({
        name: acceptedFiles[index].name,
        file: compressedFile,
        idProduit: dataProduit.id,
        count: 1,
      }));
      setImage((prevImages) => [...prevImages, ...newImages]);
      dbUploadImage(newImages);
      if (failedFiles.length > 0) {
        alert(
          `Some images failed to upload: ${failedFiles
            .map((f) => f.name)
            .join(", ")}`
        );
      }
    } catch (error) {
      console.error("Unexpected error during image upload:", error);
      alert("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingSimple(false);
    }
  }

  const deleteImage = async (index) => {
    setImage(() => images.filter((item, i) => i !== index));
    await dbDeleteImage(index);
  };

  const handleCountChange = async (index, delta) => {
    setImage((currentImages) =>
      currentImages.map((img, imgIndex) => {
        if (imgIndex === index) {
          const newCount = Math.max((img.count || 0) + delta, 0); // Ensure count doesn't go below 0
          return { ...img, count: newCount };
        }
        return img;
      })
    );
    const currentImages = [...images];
    const newCount = Math.max((currentImages[index]?.count || 0) + delta, 0);
    await editImageCount(index, newCount);
  };

  const dbVersion = 1;
  const dbName = "EventDatabase";
  const storeName = "Event";
  const imageKey = "images";

  function openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, dbVersion);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: "id" });
        }
      };
    });
  }

  async function dbUploadImage(images) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);

      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        const updatedImages = [...existingData, ...images];
        const putRequest = objectStore.put({
          id: imageKey,
          images: updatedImages,
        });
        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }

  async function dbLoadImages() {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readonly");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);

      request.onsuccess = () => {
        resolve(request.result ? request.result.images : []);
      };
      request.onerror = () => reject(request.error);
    });
  }

  async function dbDeleteAllImages() {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.delete(imageKey);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }

  async function dbDeleteImage(index) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);

      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (existingData.length <= index) {
          reject(new Error("Image index out of bounds"));
          return;
        }
        const updatedImages = existingData.filter((_, i) => i !== index);
        const putRequest = objectStore.put({
          id: imageKey,
          images: updatedImages,
        });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }

  async function dbEditImageText(index, newText) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);
      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (existingData.length <= index) {
          reject(new Error("Image index out of bounds"));
          return;
        }
        existingData[index].text = newText;
        const putRequest = objectStore.put({
          id: imageKey,
          images: existingData,
        });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }

  async function dbADDImageSrcRm(index, srcRm) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);
      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (existingData.length <= index) {
          reject(new Error("Image index out of bounds"));
          return;
        }
        existingData[index].srcRm = srcRm;
        const putRequest = objectStore.put({
          id: imageKey,
          images: existingData,
        });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }
  async function dbADDImageBg(index, Bg) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);
      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (existingData.length <= index) {
          reject(new Error("Image index out of bounds"));
          return;
        }
        existingData[index].Bg = Bg;
        const putRequest = objectStore.put({
          id: imageKey,
          images: existingData,
        });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }
  async function editImageCount(index, newCount) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction([storeName], "readwrite");
      const objectStore = transaction.objectStore(storeName);

      const request = objectStore.get(imageKey);

      request.onsuccess = () => {
        const existingData = request.result ? request.result.images : [];
        if (existingData.length <= index) {
          reject(new Error("Image index out of bounds"));
          return;
        }
        existingData[index].count = newCount;
        const putRequest = objectStore.put({
          id: imageKey,
          images: existingData,
        });

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = () => reject(putRequest.error);
      };

      request.onerror = () => reject(request.error);
    });
  }

  const memoizedDbLoadImages = useCallback(dbLoadImages, []);

  useEffect(() => {
    const loadImageInState = async () => {
      const data = await memoizedDbLoadImages();
      setImage(data);
    };
    loadImageInState();
  }, [memoizedDbLoadImages]);

  async function sendToServeur() {
    setLoading(true);
    let dataFiles = [];
    const formData = new FormData();

    images.forEach((item, i) => {
      formData.append(`${item.name}${i}`, item.file);

      const dataFile = {
        nomFile: `${item.name}${i}`,
        idproduit: item.idProduit,
        text: item.text || null,
        count: item.count || 1,
        srcRm: item.srcRm || null,
        bg: item.Bg ? item.Bg.Url : null,
      };

      dataFiles.push(dataFile);
    });

    formData.append("dataFiles", JSON.stringify(dataFiles));
    formData.append("idEvent", data.id);

    try {
      const res = await axios.post(
        `${api_base}command/AddCommandsEvent`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        }
      );

      setCode(res.data.code);
      setRoullete(true);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setLoading(false);
    }
  }

  function RemoveBgAndOpenPopup(index) {
    SetIndexImageChangeBg(index);
    if (images[index].srcRm) {
      setPopupChangeBgEtat(true);
      return;
    }
    setLoadingSimple(true);
    const formData = new FormData();
    formData.append("image", images[index].file);
    axios
      .post(`${api_base}images/RemoveBackground`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const updatedImages = [...images];
        updatedImages[index].srcRm = response.data.image;
        setImage(updatedImages);
        dbADDImageSrcRm(index, response.data.image);
        setPopupChangeBgEtat(true);
      })
      .catch((error) => {
        console.error("Error changing background:", error);
      })
      .finally(() => {
        setLoadingSimple(false);
      });
  }

  function handleChangeBg(bg) {
    const updatedImages = [...images];
    updatedImages[indexImageChangeBg].Bg = bg;
    setImage(updatedImages);
    dbADDImageBg(indexImageChangeBg, bg);
    SetIndexImageChangeBg(null);
    setPopupChangeBgEtat(false);
  }
  console.log("images :", images);
  return (
    <>
      <DrawerAppBar />
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <Box>
          <Grid
            container
            spacing={4}
            sx={{
              marginTop: "8%",
              marginBottom: {
                xs: "15%",
                md: "5%",
              },
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant="h6"
                component="h2"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                🎉 Bienvenue à l'événement :
                {data.Nom.charAt(0).toUpperCase() + data.Nom.slice(1)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={4} textAlign="center">
                {images.length === 0 && step === "intro" && (
                  <Grid item xs={12} md={6}>
                    <Box
                      component="img"
                      src={dataProduit?.ImageUpload}
                      alt="ImageTirage"
                      width="80%"
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  md={images.length === 0 ? 6 : 12}
                  textAlign="center"
                >
                  {/*
                  <CameraCapture
                    addImage={AddImage}
                    aspectRatioParametre={type === "polaroid" ? "1:1" : "3:4"}
                    step={step}
                    setStep={setStep}
                  />*/}

                  <PhotoImportCard
                    AddImage={AddImage}
                    affichage={images.length === 0}
                    event={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                width: "100%",
                marginBottom: { xs: "20%", md: "10%" },
              }}
            >
              <Grid container spacing={4} textAlign="center">
                {images?.map((img, index) => (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    key={index}
                    sx={{ width: "100%" }}
                    textAlign="center"
                  >
                    <ImageCard
                      src={URL.createObjectURL(img.file)}
                      onDelete={() => deleteImage(index)}
                      type={type}
                      badgeContent={img.count}
                      index={index}
                      handleCountChange={handleCountChange}
                      Rm_bg={data.Rm_Bg}
                      changeBackground={RemoveBgAndOpenPopup}
                      srcRm={img.srcRm ? img.srcRm : false}
                      urlBg={img.Bg ? img.Bg.Url : false}
                    />
                    <InputClientUploadFiles
                      text={img.text}
                      index={index}
                      dbEditImageText={dbEditImageText}
                      setImage={setImage}
                      type={"event"}
                      idEvent={data.id}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              position: "fixed",
              zIndex: 1000,
              backgroundColor: "white",
              padding: "8px", // أو استخدم padding: 2 (يعني 16px إذا كنت تستخدم MUI theme)
              border: "2px solid red", // تم تصحيح border
              left: 0,
              bottom: "70px",
              borderRadius: "8px",
            }}
          >
            <IconButton onClick={logoutEvent}>
              <LogoutIcon color="error" />
            </IconButton>
          </Box>

          {images.length !== 0 && (
            <>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <footer
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    borderTop: "1px solid #ccc",
                    position: "fixed",
                    left: "0",
                    bottom: "0",
                    width: "100%",
                    background: "white",
                    paddingLeft: "2%",
                    paddingRight: "2%",
                    zIndex: 1000,
                  }}
                >
                  <ImportButton
                    variant="contained"
                    height="70px"
                    startIcon={
                      <Badge
                        badgeContent={images.length}
                        sx={{
                          "& .MuiBadge-badge": {
                            color: "#e63e57",
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <AddShoppingCartIcon />
                      </Badge>
                    }
                    onClick={sendToServeur}
                  >
                    imprimer
                  </ImportButton>
                </footer>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <footer
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "fixed",
                    left: "0",
                    bottom: "0",
                    width: "100%",
                    background: "white",
                    paddingLeft: "2%",
                    paddingRight: "2%",
                    zIndex: 1000,
                  }}
                >
                  <ImportButton
                    variant="contained"
                    fullWidth
                    height="70px"
                    startIcon={
                      <Badge
                        badgeContent={images.length}
                        fontSize="large"
                        sx={{
                          "& .MuiBadge-badge": {
                            color: "#e63e57",
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <AddShoppingCartIcon />
                      </Badge>
                    }
                    onClick={sendToServeur}
                  >
                    imprimer
                  </ImportButton>
                </footer>
              </Box>
            </>
          )}
          <ConfirmClientTextPopup
            open={popupConfirm}
            onClose={() => {
              setPopupConfirm(false);
            }}
            confirm={() => {
              setPopupConfirm(false);
              sendToServeur();
            }}
          />

          <SuccessWithRouletteDialog
            open={Roullete}
            onClose={() => {
              dbDeleteAllImages();
              setImage([]);
              setRoullete(false);
              //  Navigate("/");
            }}
            code={code}
          />
          <BackLoading open={loading} Progress={progress} />
          <BackLoadingSimple open={loadingSimple} />
          <PopupChangeBg
            open={PopupChangeBgEtat}
            onClose={() => setPopupChangeBgEtat(false)}
            imageWithoutBg={images[indexImageChangeBg]?.srcRm}
            bgList={data.BackgroundEvents}
            onSave={handleChangeBg}
          />
        </Box>
      </div>
    </>
  );
}
